import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en.json';
import sv from '@/locales/sv.json';

// Get stored language safely with validation
const getStoredLanguage = (): string => {
  try {
    const stored = localStorage.getItem('language');
    // Validate that it's one of our supported languages
    if (stored && ['en', 'sv'].includes(stored)) {
      return stored;
    }
  } catch (error) {
    console.error('Error accessing localStorage:', error);
  }
  return 'en'; // Default fallback
};

// Update HTML lang attribute when language changes
const updateHtmlLang = (language: string) => {
  document.documentElement.lang = language;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sv: { translation: sv },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Set initial HTML lang attribute
updateHtmlLang(i18n.language);

// Listen for language changes and update HTML lang attribute + localStorage
i18n.on('languageChanged', (lng) => {
  updateHtmlLang(lng);
  try {
    localStorage.setItem('language', lng);
  } catch (error) {
    console.error('Error saving language to localStorage:', error);
  }
});

export default i18n;
